import { useState, useEffect } from 'react';
import { css } from '@eti/styles';
import { useSiteContext, useTranslation } from '@eti/providers';
import { Button, Text, textVariants } from '@etg/wings';
import { getSeatIconComponent } from '../../utils/getSeatIconComponent';
import { seatButtonStyles } from '../../utils/styles';
import SeatTooltip from './SeatTooltip';
import SeatTooltipWithPriceBreakdown from './SeatTooltipWithPriceBreakdown';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const selectedSeatInitialsStyles = css`
  left: 0;
  position: absolute;
  right: 0;
  text-align: center;
`;
const BookableSeat = _ref => {
  let {
    carrier,
    column,
    isRyanairInTrip,
    isSelected,
    mainCharacteristic,
    markup,
    onChange,
    price,
    row,
    seat,
    seatTypeLabel,
    selectedSeatInitials
  } = _ref;
  const {
    brand
  } = useSiteContext();
  const {
    t
  } = useTranslation();
  const tooltipId = `seat_${seat}`;
  const [SeatIconComponent, setSeatIconComponent] = useState();
  useEffect(() => {
    const loadIcon = async () => {
      const iconComponent = await getSeatIconComponent(brand.code, mainCharacteristic, isSelected);
      setSeatIconComponent(() => iconComponent);
    };
    loadIcon();
  }, [brand, mainCharacteristic, isSelected]);
  const handleClick = onChange({
    price,
    carrier,
    column,
    row,
    seat,
    markup
  });
  return /*#__PURE__*/_jsxs(Button, {
    className: seatButtonStyles,
    "data-for": tooltipId,
    "data-seat-id": `bookableSeat-${row}-${seat}`,
    "data-testid": `bookableSeat-${row}-${seat}`,
    "data-tip": true,
    onClick: handleClick,
    children: [isSelected && /*#__PURE__*/_jsx(Text, {
      "aria-label": t('ScreenReader.Seatmap.Seat.Selected.Action'),
      className: selectedSeatInitialsStyles,
      variant: textVariants._12_BOLD,
      children: selectedSeatInitials
    }), SeatIconComponent && /*#__PURE__*/_jsx(SeatIconComponent, {
      "aria-hidden": "true"
    }), isRyanairInTrip && carrier ? /*#__PURE__*/_jsx(SeatTooltipWithPriceBreakdown, {
      carrier: carrier,
      id: tooltipId,
      markup: markup,
      price: price,
      seat: seat,
      seatTypeLabel: seatTypeLabel
    }) : /*#__PURE__*/_jsx(SeatTooltip, {
      id: tooltipId,
      price: price,
      seat: seat,
      seatTypeLabel: seatTypeLabel
    })]
  });
};
export default BookableSeat;
//# sourceMappingURL=BookableSeat.js.map